import React, { useEffect, useState } from "react";
import DeliveriesTable from "../../components/Delivery/DeliveriesTable";
import { Box, Tab, Tabs, Typography } from "@mui/material";
import { Route, Link as RouterLink, Routes, useLocation } from "react-router-dom";
import DeliveriesHealthChecks from "../../components/Delivery/DeliveriesHealthChecks";

const DeliveriesSummaryPage: React.FC = () => {
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedTabName, setSelectedTabName] = useState("Summary");

  const tabs = [
    { name: "Summary", path: "/deliveries/summary" },
    { name: "Health", path: "/deliveries/health" },
  ]

  useEffect(() => {
    const currentTabIndex = tabs.findIndex((tab) =>
      location.pathname.endsWith(tab.path.split("/").pop() || "")
    );
    setSelectedTab(currentTabIndex === -1 ? 0 : currentTabIndex);
    setSelectedTabName(
      currentTabIndex === -1 ? tabs[0].name : tabs[currentTabIndex].name
    );
  }, [location.pathname]);

  useEffect(() => {
    document.title = `Deliveries - ${selectedTabName}`;
  }, [location]);


  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Deliveries
      </Typography>
      <Tabs
        value={selectedTab}
        onChange={(e, newValue) => setSelectedTab(newValue)}
        sx={{ marginBottom: 2 }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.path}
            label={tab.name}
            component={RouterLink}
            to={tab.path}
          />
        ))}
      </Tabs>
      <Routes>
        <Route
          path="summary"
          element={<DeliveriesTable />}
        />
        <Route
          path="health"
          element={<DeliveriesHealthChecks />}
        />
        <Route
          path="/"
          element={<DeliveriesTable />}
        />
      </Routes>
    </Box>
  );
};
export default DeliveriesSummaryPage;
